import { useMemo } from "react";
import { Typography } from "antd";
import { normalizedIncludes } from "@/utils/stringUtils";
import { SortGroup } from "./SortGroup";
import { AvailableListProps } from "./types";
import InfoTooltip from "../../InfoTooltip";
const { Text } = Typography;

export const AvailableList = ({
  visibleColumns,
  hiddenColumns,
  sortList,
  setSortList,
  columnsTitleCreator,
  searchTerm,
}: AvailableListProps) => {
  const availableColumns = useMemo(() => {
    const allColumns = [...(visibleColumns ?? []), ...(hiddenColumns ?? [])];

    return allColumns.filter((column) => {
      const isInSortList = sortList?.some((sort) => sort.field === column);
      if (isInSortList) return false;

      if (searchTerm) {
        const displayTitle = columnsTitleCreator(column);
        return normalizedIncludes(displayTitle, searchTerm);
      }

      return true;
    });
  }, [
    visibleColumns,
    hiddenColumns,
    sortList,
    searchTerm,
    columnsTitleCreator,
  ]);

  return (
    <>
      <h2
        data-testid="sorting-available-heading"
        className="sticky top-0 bg-white text-sm font-bold text-[#2B4752] mb-2 pb-1 z-10"
      >
        <span>
          AVAILABLE
          <span className="text-gray-500 ml-1">
            ({availableColumns.length})
          </span>
        </span>
        <span className="text-gray-500 text-xs ml-3">
          <InfoTooltip
            title="Includes shown and hidden filters"
            fill="#6b7280"
            iconSize={12}
          />
        </span>
      </h2>
      {availableColumns.length > 0 ? (
        availableColumns.map((fieldName) => (
          <SortGroup
            key={fieldName}
            fieldName={fieldName}
            sortList={sortList}
            setSortList={setSortList}
            columnsTitleCreator={columnsTitleCreator}
            isDraggable={false}
          />
        ))
      ) : (
        <Text className="text-gray-400">No available columns to sort</Text>
      )}
    </>
  );
};
